import { Pipe, PipeTransform } from '@angular/core'
/**
 * guest report에서, host가 삭제된 경우를 파악하는 pipe
 */
@Pipe({
  name: 'isHostReportRemoved',
})
export class IsHostReportRemovedPipe implements PipeTransform {
  constructor() {}

  transform(value?: {
    hostQuizReport?: {
      isRemoved: boolean
    }
  }): boolean {
    if (!value?.hostQuizReport || (value.hostQuizReport as any).isRemoved) {
      return true
    }
    return false
  }
}
